import React from 'react'
import {GridColDef} from '@mui/x-data-grid'
import {Chip} from '@mui/material'
import {BulkUploadBatchEvent} from '../../redux/modules/bulkUploadBatches'
import {ACTION_TYPE_LABELS} from './allEventsColumn'

export const createBulkUploadEventsColumns = (): GridColDef[] => [
  {
    field: 'id',
    headerName: 'ID',
    flex: 2,
  },
  {
    field: 'actionType',
    headerName: 'Action Type',
    flex: 2,
    renderCell: params => {
      const row = params.row as BulkUploadBatchEvent
      if (row.failed) {
        return <Chip label="Failed" color="warning" size="small" />
      }
      return (
        <Chip
          label={ACTION_TYPE_LABELS[row.actionType] ?? String(row.actionType)}
          color="primary"
          variant="outlined"
          size="small"
        />
      )
    },
  },
  {
    field: 'patient',
    headerName: 'Patient',
    flex: 2,
    valueGetter: params => {
      const row = params.row as BulkUploadBatchEvent
      if (row.failed) {
        return row.patientName || '--'
      }
      return row.patient ? `${row.patient.firstName} ${row.patient.lastName}` : '--'
    },
  },
  {
    field: 'deviceUdid',
    headerName: 'Device UDID',
    flex: 2,
    valueGetter: params => {
      const row = params.row as BulkUploadBatchEvent
      if (row.failed) {
        return row.deviceSerial || '--'
      }
      return row.device?.udid || '--'
    },
  },
]
